const Founder = () => {
  const achievements = [
    'Hơn 24 năm kinh nghiệm trong lĩnh vực đào tạo, kinh doanh, bán hàng, lãnh đạo...',
    'Hơn 15 năm kinh nghiệm Quản lý cấp cao các tập đoàn đa quốc gia tại Việt Nam như Manulife, AIA, Avon, Amway, ICP X-men, Nuskin',
    'Top 1% người làm thuê có thu nhập cao số 1 Việt Nam năm 2022',
    'Chứng chỉ: NLP Master, NLP Coach, Hyposis Therapy, ICF Coach',
  ];

  const speakingEvents = [
    'Internet marketing từ A-Z năm 2017',
    'Business Summit 2018',
    'Success Summit 2019',
    'Kinh doanh & Khởi nghiệp trong thời đại số 2020',
  ];

  const famousSpeakers = [
    'Blair Singer',
    'Nick Vujicic',
    'Lê Thẩm Dương',
    'Hoàng Nam Tiền',
    'Shark Hưng',
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              GẶP GỠ NHÀ SÁNG LẬP & CEO
            </h2>
            <h3 className="text-2xl md:text-3xl font-bold text-gradient mb-4">
              NGUYỄN NGỌC HUY
            </h3>
            <p className="text-lg text-gray-600">
              Người dẫn dắt và truyền cảm hứng cho hàng chục nghìn học viên
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Profile Image */}
            <div className="relative">
              <div className="bg-gradient-to-br from-primary to-primary-700 rounded-2xl p-8 text-white text-center">
                <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white/20">
                  <img
                    src="/assets/images/Nguyen-Ngoc-Huy.jpg"
                    alt="Nguyễn Ngọc Huy - Founder & CEO UPOWER GROUP"
                    className="w-full h-full object-cover"
                    onError={e => {
                      // Fallback to placeholder if image fails to load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="w-full h-full bg-white/20 rounded-full hidden items-center justify-center">
                    <svg
                      className="w-24 h-24 text-white/80"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                <h4 className="text-2xl font-bold mb-2">Nguyễn Ngọc Huy</h4>
                <p className="text-primary-100 font-medium">
                  Founder & CEO UPOWER GROUP
                </p>
              </div>

              {/* Quote */}
              <div className="mt-6 mb-6 bg-white rounded-2xl p-6 shadow-lg border-l-4 border-primary">
                <blockquote className="text-gray-700 italic text-lg">
                  &ldquo;Thành công không phải là đích đến, mà là hành trình
                  không ngừng phát triển bản thân và cống hiến cho cộng
                  đồng.&rdquo;
                </blockquote>
                <cite className="block mt-4 text-primary font-semibold">
                  - Nguyễn Ngọc Huy
                </cite>
              </div>
              {/* Call to Action */}
              <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-6 md:p-8 text-white text-center">
                <h4 className="text-xl font-bold mb-4">
                  Sẵn sàng học hỏi từ chuyên gia?
                </h4>
                <p className="mb-6 text-primary-100">
                  Tham gia các khóa học do chính CEO Nguyễn Ngọc Huy trực tiếp
                  giảng dạy
                </p>
                <a
                  href="https://zalo.me/g/guiurp272"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-primary font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-300 inline-block"
                >
                  Xem Lịch Khóa Học
                </a>
              </div>
            </div>

            {/* Content */}
            <div className="space-y-8">
              {/* Achievements */}
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg">
                <h4 className="text-2xl font-bold text-primary mb-6">
                  Thành tựu nổi bật
                </h4>
                <ul className="space-y-4">
                  {achievements.map((achievement, index) => (
                    <li key={index} className="flex items-start">
                      <svg
                        className="w-5 h-5 text-primary mt-1 mr-3 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-gray-700 leading-relaxed">
                        {achievement}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Speaking Events */}
              <div className="bg-primary-50 rounded-2xl p-6 md:p-8">
                <h4 className="text-2xl font-bold text-primary mb-6">
                  Diễn giả các chương trình uy tín
                </h4>
                <div className="grid md:grid-cols-2 gap-4 mb-6">
                  {speakingEvents.map((event, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg p-4 shadow-sm"
                    >
                      <span className="text-gray-700 font-medium">{event}</span>
                    </div>
                  ))}
                </div>

                <div className="border-t border-primary/20 pt-6">
                  <h5 className="text-lg font-semibold text-primary mb-3">
                    Cùng những diễn giả nổi tiếng:
                  </h5>
                  <div className="flex flex-wrap gap-2">
                    {famousSpeakers.map((speaker, index) => (
                      <span
                        key={index}
                        className="bg-primary text-white px-3 py-1 rounded-full text-sm font-medium"
                      >
                        {speaker}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
